import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LOGIN_CUSTOM_ENDPOINTS } from '../config';

const useReturnToUrl = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const url = new URL(window.location.href);
    const returnToUrl = url.searchParams.get('returnToUrl')?.toString() ?? '';
    if (returnToUrl) {
      localStorage.setItem('returnToUrl', returnToUrl);

      // Remove from URL
      url.searchParams.delete('returnToUrl');
      navigate(`${url.pathname}?${url.searchParams}`, { replace: true });
    }
  }, []);

  const getReturnToUrl = () => {
    return localStorage.getItem('returnToUrl') ?? '';
  };

  const deleteUrlFromStorage = () => {
    localStorage.removeItem('returnToUrl');
  };

  const SignInURL = () => {
    const returnToUrl = getReturnToUrl();

    if (!returnToUrl) {
      return window.location.origin;
    }

    try {
      const parsedUrl = new URL(returnToUrl);

      const isHttpProtocol = ['http:', 'https:'].includes(parsedUrl.protocol);

      if (!isHttpProtocol) {
        return parsedUrl.toString();
      }

      const customEndPoint = LOGIN_CUSTOM_ENDPOINTS?.find(
        url => new URL(url).host === parsedUrl.host
      );

      return customEndPoint || parsedUrl.toString();
    } catch {
      return window.location.origin;
    }
  };

  return {
    getReturnToUrl,
    deleteUrlFromStorage,
    SignInURL,
  };
};

export default useReturnToUrl;
